import { JsonLd } from 'react-schemaorg';
import type { Car } from 'schema-dts';

interface SchemaCarProps {
  name: string;
  vehicleIdentificationNumber: string;
  image?: string[];
  url: string;
  price: number;
  priceCurrency: string;
  mileageFromOdometerValue: number;
  brandName: string;
  model: string;
  vehicleConfiguration: string;
  vehicleModelDate: string;
  color?: string;
  vehicleInteriorColor?: string;
  vehicleInteriorType?: string;
  bodyType: string;
  driveWheelConfiguration:
    | 'AllWheelDriveConfiguration'
    | 'FourWheelDriveConfiguration'
    | 'FrontWheelDriveConfiguration'
    | 'RearWheelDriveConfiguration';
  fuelType: string;
  vehicleTransmission: string;
  numberOfDoors?: number;
  vehicleSeatingCapacity?: number;
}

const SchemaCar = ({
  name,
  vehicleIdentificationNumber,
  image,
  url,
  price,
  priceCurrency,
  mileageFromOdometerValue,
  brandName,
  model,
  vehicleConfiguration,
  vehicleModelDate,
  color,
  vehicleInteriorColor,
  vehicleInteriorType,
  bodyType,
  driveWheelConfiguration,
  fuelType,
  vehicleTransmission,
  numberOfDoors,
  vehicleSeatingCapacity,
}: SchemaCarProps) => (
  <JsonLd<Car>
    item={{
      '@context': 'https://schema.org',
      '@type': 'Car',
      name,
      vehicleIdentificationNumber,
      image,
      url,
      offers:
        price && priceCurrency
          ? {
              '@type': 'Offer',
              availability: 'https://schema.org/InStock',
              price,
              priceCurrency,
            }
          : undefined,
      itemCondition:
        mileageFromOdometerValue > 0
          ? 'https://schema.org/UsedCondition'
          : 'https://schema.org/NewCondition',
      brand: {
        '@type': 'Brand',
        name: brandName,
      },
      model,
      vehicleConfiguration,
      vehicleModelDate,
      mileageFromOdometer: {
        '@type': 'QuantitativeValue',
        value: mileageFromOdometerValue.toString(),
        unitCode: 'KMT',
      },
      color,
      vehicleInteriorColor,
      vehicleInteriorType,
      bodyType,
      driveWheelConfiguration: `https://schema.org/${driveWheelConfiguration}`,
      vehicleEngine: {
        '@type': 'EngineSpecification',
        fuelType,
      },
      vehicleTransmission,
      numberOfDoors,
      vehicleSeatingCapacity,
    }}
  />
);

export default SchemaCar;
